import { forwardRef } from 'react'
import { Link, type LinkProps, useMatch } from '@remix-run/react'
import { route } from 'routes-gen'

export const LinkToAnlegerfragebogen = forwardRef<HTMLAnchorElement, Omit<LinkProps, 'to'>>(
  (props, ref) => {
    const match = useMatch({ path: '/kundenzugang/depot/:id', end: false })
    return (
      // eslint-disable-next-line jsx-a11y/anchor-has-content
      <Link
        {...props}
        ref={ref}
        to={
          match && match.params.id
            ? route('/kundenzugang/anlegerfragebogen/:depotId', { depotId: match.params.id })
            : route('/kundenzugang/anlegerfragebogen')
        }
      />
    )
  }
)
LinkToAnlegerfragebogen.displayName = 'LinkToAnlegerfragebogen'

export const useUrlToAnlegerfragebogen = () => {
  const match = useMatch({ path: '/kundenzugang/depot/:id', end: false })
  return match && match.params.id
    ? route('/kundenzugang/anlegerfragebogen/:depotId', { depotId: match.params.id })
    : route('/kundenzugang/anlegerfragebogen')
}
